.divider {
  width: 1px;
  background-color: #eee;
  margin: 0 4px;
}
